/**
 * Kleine Anzeige-Bausteine der SuggestionCard: Push-Status-Pill, Reasoning-Zeile,
 * Regel-Warnhinweis. Ausgelagert, damit die Card unter dem Component-Size-Limit
 * bleibt (T7, additive Erweiterung für die Bulk-Text-Review-Queue).
 */
import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { DV2 } from './tokens'

/** Push-Ergebnis eines übernommenen Vorschlags (Bulk-Text-Review). */
export function PushStatusPill({ status }: { status: 'ok' | 'failed' }) {
  const { t } = useTranslation()
  const isOk = status === 'ok'
  return (
    <span
      className={`rounded-full border px-2 py-0.5 text-2xs ${
        isOk ? `${DV2.addBd} ${DV2.addBg} ${DV2.addFg}` : `${DV2.errBd} ${DV2.errBg} ${DV2.errFg}`
      }`}
    >
      {isOk ? t('channelContent.card.pushOk') : t('channelContent.card.pushFailed')}
    </span>
  )
}

/** „Begründung der KI"-Zeile (orange Tag) — Freitext aus `reasoning` (Q3). */
export function ReasoningLine({ text }: { text: string }) {
  const { t } = useTranslation()
  return (
    <p className={`flex gap-2 text-xs ${DV2.fg3}`}>
      <span className="flex-none text-2xs font-bold uppercase tracking-wide text-primary-500">
        {t('channelContent.card.reasoning')}
      </span>
      <span>{text}</span>
    </p>
  )
}

/** Amber-Hinweis, wenn der Vorschlag die Regel noch nicht ganz erfüllt. */
export function RuleComplianceWarning() {
  const { t } = useTranslation()
  return (
    <div className={`flex items-start gap-2 rounded-lg border ${DV2.warnBd} ${DV2.warnBg} px-3 py-2 text-xs ${DV2.fg2}`}>
      <AlertTriangle size={14} className="text-amber-300 flex-shrink-0 mt-0.5" />
      <div className="flex flex-col gap-1">
        <b className={DV2.fg1}>{t('channelContent.card.compliantWarningTitle')}</b>
        <span className="text-xs-plus opacity-85">{t('channelContent.card.compliantWarningBody')}</span>
      </div>
    </div>
  )
}
